import { observer } from 'mobx-react';
import { FC } from 'react';

import { CenteredSpinner } from '@servicetitan/standalone-ui';
import { provide, useDependencies } from '@servicetitan/react-ioc';
import { Loader } from '@servicetitan/web-components';

import { RetentionSegmentsStore } from '../stores/retention-segments.store';

export const RetentionSegmentsPage: FC = provide({
    singletons: [RetentionSegmentsStore],
})(
    observer(() => {
        const [{ data, source, basename }] = useDependencies(RetentionSegmentsStore);

        return (
            <Loader
                className="w-100"
                data={data}
                src={source}
                basename={basename}
                loadingFallback={<CenteredSpinner />}
            />
        );
    }),
);
